/* OVREL collection page: filter dialog, sort, load more, description clamp. */
(function () {
  'use strict';
  var OV = window.OV; if (!OV) return;
  var $ = OV.$, $$ = OV.$$;

  /* filters dialog */
  var dlg = $('#ov-filters');
  $$('[data-ov-filters-open]').forEach(function (b) {
    b.addEventListener('click', function () { OV.openDialog(dlg, b); });
  });
  document.addEventListener('click', function (e) {
    var f = e.target.closest('[data-ov-filter]');
    if (!f) return;
    var raw = f.getAttribute('data-ov-filter');
    OV.track('filter_used', { collection: OV.context.list && OV.context.list.handle, filter: raw.split(':')[0], value: raw.split(':').slice(1).join(':'), action: f.classList.contains('is-active') ? 'remove' : 'add' });
  });

  /* sort: keep the current tag path and native filter params */
  var sort = $('[data-ov-sort] select');
  if (sort) sort.addEventListener('change', function () {
    var u = new URL(location.href);
    u.searchParams.set('sort_by', sort.value);
    u.searchParams.delete('page');
    OV.track('filter_used', { collection: OV.context.list && OV.context.list.handle, filter: 'sort', value: sort.value });
    location.href = u.toString();
  });

  /* description clamp: only offer "More" when the text is actually cut */
  $$('[data-ov-clamp]').forEach(function (b) {
    var t = document.getElementById(b.getAttribute('data-ov-clamp'));
    if (!t) return;
    if (t.scrollHeight > t.clientHeight + 4) b.hidden = false;
    b.addEventListener('click', function () {
      var open = t.classList.toggle('is-open');
      b.textContent = open ? 'Less' : 'More';
    });
  });

  /* load more (v39): every work arrives without a click. The next page is requested through the
     Section Rendering API when the end of the grid comes within ~1.5 screens, so a visitor who keeps
     scrolling sees all of them; the button stays as a fallback (no IntersectionObserver, a failed
     request) and real pagination links stay in the markup for no-JS and crawlers. */
  var more = $('[data-ov-more]');
  if (more) {
    var pages = $('[data-ov-pages]', more);
    if (pages) pages.hidden = true;
    var sectionId = more.getAttribute('data-ov-section');
    var loading = false, failures = 0, io = null;

    function nextLink() { return $('[data-ov-next]', more); }

    function sectionUrl(href) {
      var u = new URL(href, location.href);
      if (sectionId) u.searchParams.set('section_id', sectionId);
      return u.toString();
    }

    function loadNext(fromClick) {
      var next = nextLink();
      if (!next || loading) return;
      loading = true;
      next.setAttribute('aria-busy', 'true');
      more.classList.add('is-loading');
      fetch(sectionUrl(next.href), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = $('[data-ov-grid]');
          var incoming = doc.querySelector('[data-ov-grid]');
          if (!grid || !incoming) throw new Error('no grid in response');
          var have = {};
          $$('[data-ov-item]', grid).forEach(function (c) { have[c.getAttribute('data-ov-item')] = true; });
          var first = null, added = 0;
          Array.prototype.slice.call(incoming.children).forEach(function (c) {
            if (c.classList.contains('ov-break')) return;
            var key = c.getAttribute('data-ov-item');
            if (key && have[key]) return; /* the catalogue can shift between requests: never show a work twice */
            var n = document.importNode(c, true);
            if (!first) first = n;
            grid.appendChild(n);
            added++;
          });
          var shown = $('[data-ov-shown]', more);
          if (shown) shown.textContent = String($$('[data-ov-item]', grid).length);
          var nm = doc.querySelector('[data-ov-more]');
          var nn = nm && nm.querySelector('[data-ov-next]');
          if (nn) { next.href = nn.getAttribute('href'); next.removeAttribute('aria-busy'); }
          else { next.remove(); if (io) io.disconnect(); more.classList.add('is-done'); }
          failures = 0;
          /* only a click moves focus; scrolling must never pull the page */
          if (fromClick) {
            var link = first && first.querySelector('.ov-card__link');
            if (link) link.focus({ preventScroll: true });
          }
          if (added) OV.announce(added + ' more works loaded');
          loading = false;
          more.classList.remove('is-loading');
          /* a very tall screen can show the sentinel again straight away */
          if (io && nn) requestAnimationFrame(check);
        })
        .catch(function () {
          loading = false;
          more.classList.remove('is-loading');
          var n = nextLink();
          if (n) n.removeAttribute('aria-busy');
          failures++;
          /* stop auto-loading after repeated failures; the button still works as a normal link */
          if (failures >= 2 && io) { io.disconnect(); io = null; }
          if (fromClick && n) location.href = n.href;
        });
    }

    function check() {
      var n = nextLink();
      if (!n) return;
      var r = more.getBoundingClientRect();
      if (r.top < window.innerHeight * 2.5) loadNext(false);
    }

    more.addEventListener('click', function (e) {
      var next = e.target.closest('[data-ov-next]');
      if (!next) return;
      e.preventDefault();
      loadNext(true);
    });

    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        if (entries.some(function (en) { return en.isIntersecting; })) loadNext(false);
      }, { rootMargin: '0px 0px 150% 0px' });
      io.observe(more);
    }
  }
})();
